/* eslint-disable */

'use strict';
import $ from 'jquery';
import UIkit from 'UIkit';
import Inputmask from 'inputmask';
// import {  TweenMax} from "gsap";
// import datetimepicker from "jquery-datetimepicker";
// import marquee from "jquery.marquee";

import 'lazysizes';
// import Swiper from 'swiper';
// import Swiper from 'swiper/bundle';
// import { tree } from "gulp";
import Scrollbar from 'smooth-scrollbar';
import './form.js';

import {ymap as ymapEcoCenter} from './map-eco-center';
// import {ymap as ymapHowDoMetro} from './map-how-do-metro';
// import {ymap as ymapHowDoAuto} from './map-how-do-auto';

// $('.klademug').each(function () {
//   $(this).prop('Counter', 0).animate({
//     Counter: 100
//   }, {
//     duration: 2000,
//     easing: 'swing',
//     step: function (now) {
//       $(this).text(Math.ceil(now) + '%');
//     }
//   });
// });

// функция возвращает cookie с именем name, если есть, если нет, то undefined
function getCookie(name) {
	let matches = document.cookie.match(
		new RegExp(
			'(?:^|; )' +
				name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') +
				'=([^;]*)'
		)
	);
	return matches ? decodeURIComponent(matches[1]) : undefined;
}
let cookiecook = getCookie('cookiecook'),
	cookiewin = document.getElementsByClassName('cookie-warning')[0];
if (cookiewin) {
	// проверяем, есть ли у нас cookie, с которой мы не показываем окно и если нет, запускаем показ
	if (cookiecook != 'no') {
		// показываем
		cookiewin.style.display = 'block';
		// закрываем по клику
		document
			.getElementById('cookie-close-2')
			.addEventListener('click', function () {
				cookiewin.style.display = 'none';
				// записываем cookie на 1 день, с которой мы не показываем окно
				let date = new Date();
				date.setDate(date.getDate() + 30);
				document.cookie =
					'cookiecook=no; path=/; expires=' + date.toUTCString();
			});
	}
}

if ($(window).width() > 639) {
	setTimeout(() => {
		let preloaderEl2 = document.getElementById('preloader2');
		let preloaderEl1 = document.getElementById('preloader1');
		$('body').attr('style', '');
		if (preloaderEl2) {
			preloaderEl2.classList.add('hidden');
		}
		if (preloaderEl1) {
			preloaderEl1.classList.add('hidden');
		}
		$('#main-banner__container1').attr(
			'uk-scrollspy',
			'target: .main-banner__anim; cls: uk-animation-slide-bottom; delay: 400'
		);
		$('.banner-item-decor').addClass('active');
	}, 2000);
} else {
	setTimeout(() => {
		let preloaderEl2 = document.getElementById('preloader2');
		let preloaderEl1 = document.getElementById('preloader1');
		$('body').attr('style', '');
		if (preloaderEl2) {
			preloaderEl2.classList.add('hidden');
		}
		if (preloaderEl1) {
			preloaderEl1.classList.add('hidden');
		}
		$('#main-banner__container1').attr(
			'uk-scrollspy',
			'target: .main-banner__anim; cls: uk-animation-slide-bottom; delay: 400'
		);
		$('.banner-item-decor').addClass('active');
	}, 1000);
}

$(document).ready(function () {
if ($(window).width() > 639) {
	let arrPreloadPath = $('.svg-preload2 path');
	const svgPreload2X = 234.685;
	const svgPreload2Y = 317.012;
	$('.svg-preload2').css(`opacity`, `1`);
	for (let index = 0; index < arrPreloadPath.length; index++) {
		const element = arrPreloadPath[index];
		const style = window.getComputedStyle(element);
		let matrix =
			style.transform || style.webkitTransform || style.mozTransform;
		let matrixValues = '';
		if(!matrix || matrix === 'none') {
			matrix = style.MozPerspectiveOrigin;
			// matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
		} else {
			matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(', ');
		}

		

		const elementX = Number(matrixValues[4]);
		const elementY = Number(matrixValues[5]);
		if (index === 3) {
			$(element).css(
				`transform`,
				`translate(${(elementX * 100) / svgPreload2X}%, 100%`
			);
		} else {
			$(element).css(
				`transform`,
				`translate(${(elementX * 100) / svgPreload2X}%,  ${
					(elementY * 3500) / svgPreload2Y
				}%)`
			);
		}

		setTimeout(() => {
			$(element).css(`transition`, `2s`);
			$(element).css(
				`transform`,
				`translate(${(elementX * 100) / svgPreload2X}%,  ${
					(elementY * 100) / svgPreload2Y
				}%)`
			);
		}, 100);
	}
} else {
	// let arrPreloadPath = $('.svg-preload2 path');
	// const svgPreload2X = 234.685;
	// const svgPreload2Y = 317.012;
	$('.svg-preload2').css(`opacity`, `1`);
}
});
$(document).ready(function () {

	if(document.querySelector('#map-eco-center')) {
		ymaps.ready(ymapEcoCenter);
	}

	//сверка паролей
	$('#pass, #pass2').keyup(validateInputPassword);

	function validateInputPassword() {
		var pass1 = $('#pass').val();
		var pass2 = $('#pass2').val();

		if (pass1.length < 6) {
			$('#sw').text('Длина пароля менее 6 символов');
			$('#sw').css('color', 'red');
		} else if (pass1 == pass2) {
			$('#sw').text('Пароли совпадают');
			$('#sw').css('color', 'green');
		} else {
			$('#sw').text('Пароли не совпадают');
			$('#sw').css('color', 'red');
		}
	}

	//показать скрыть значения поля пароли
	[...document.querySelectorAll('.input-pass-container')].forEach((el) => {
		const svg = el.querySelector('.svg-show-pass');
		const input = el.querySelector('input');

		svg.addEventListener('click', (e) => {
			if (input.type === 'password') {
				input.type = 'text';
				svg.classList.add('active');
			} else {
				svg.classList.remove('active');
				input.type = 'password';
			}
		});
	});

	//изменить значения инпута
	[...document.querySelectorAll('.input-change-container')].forEach((el) => {
		const svg = el.querySelector('.svg-edit');
		const input = el.querySelector('input');

		svg.addEventListener('click', (e) => {
			if (input.classList.contains('point-event-none')) {
				input.classList.remove('point-event-none');
				svg.classList.add('active');
			} else {
				svg.classList.remove('active');
				input.classList.add('point-event-none');
			}
		});
	});

	UIkit.util.on('#slideshow-main', 'itemshown', function (e) {
		if (e.detail[0].index + 1 == 1) {
			$('.link-place span').text('Чамар-Дабан, Сибирь, Россия');
		} else {
			$('.link-place span').text('Алтай, Россия');
		}
	});

	if ($(window).width() > 1199) {
		Array.from(document.querySelectorAll('.not-found__svg1 > svg')).map(
			(el) => {
				window.addEventListener('mousemove', function (e) {
					let x = e.clientX / window.innerWidth;
					let y = e.clientY / window.innerHeight;
					el.style.transform =
						'translate(-' + x * 50 + 'px, -' + y * 50 + 'px)';
				});
			}
		);
	}

	//checked inputs text
	const checkedSwitch = function (element, th) {
		if ($(th).is(':checked')) {
			element.querySelectorAll('.switch-name')[0].classList.remove('active');
			element.querySelectorAll('.switch-name')[1].classList.add('active');

			if ($('.help-stage_every-month')) {
				$('.help-stage_1').hide();
				$('.help-stage_2').hide();
				$('.help-stage_3').hide();
				$('.help-stage_every-month').fadeIn();
				[...document.querySelectorAll('.switch-round input')].forEach((el) => {
					el.checked = true;
				});
				[...document.querySelectorAll('.switch-name')].forEach((el) => {
					if (el.textContent === 'Ежемесячное') {
						el.classList.add('active');
					} else {
						el.classList.remove('active');
					}
				});
			}
		} else {
			element.querySelectorAll('.switch-name')[1].classList.remove('active');
			element.querySelectorAll('.switch-name')[0].classList.add('active');

			if ($('.help-stage_every-month')) {
				$('.help-stage_every-month').hide();
				$('.help-stage_1').fadeIn();
				[...document.querySelectorAll('.switch-round input')].forEach((el) => {
					el.checked = false;
				});
				[...document.querySelectorAll('.switch-name')].forEach((el) => {
					if (el.textContent === 'Разовое') {
						el.classList.add('active');
					} else {
						el.classList.remove('active');
					}
				});
			}
		}
	};
	Array.from(document.querySelectorAll('.switch-container')).forEach(
		(element, index) => {
			checkedSwitch(element, element.querySelector('input'));
			element
				.querySelectorAll('.switch-name')[0]
				.addEventListener('click', function () {
					element.querySelector('input').checked = false;
					checkedSwitch(element, element.querySelector('input'));
				});
			element
				.querySelectorAll('.switch-name')[1]
				.addEventListener('click', function () {
					element.querySelector('input').checked = true;
					checkedSwitch(element, element.querySelector('input'));
				});
			element.querySelector('input').addEventListener('change', function (e) {
				checkedSwitch(element, this);
			});
		}
	);

	if ($(window).width() > 1199) {
		document.querySelectorAll('.project-preview').forEach((element) => {
			element.addEventListener('mousemove', function (event) {
				$('.js-cursor').addClass('active');
				var x, y, z;

				x = event.clientX - 15;
				y = event.clientY - 15;
				z = event.pageY;
				$('.js-cursor').css('left', function () {
					x = event.pageX - 55;
					return x;
				});
				$('.js-cursor').css('top', function () {
					y = event.pageY - 55;
					return y;
				});
			});
			element.addEventListener('mouseout', function (event) {
				$('.js-cursor').removeClass('active');
			});
		});
	}

	const sliderCounter = document.querySelectorAll('.slider__counter');
	sliderCounter.forEach((element) => {
		//Счетчик слайда яхт
		UIkit.util.on(element, 'itemshown', function (e) {
			// $('#yacht__slider1 .slider_number').text(e.detail[0].index + 1);
			$(element)
				.find('.slider_number')
				.text(('0' + (e.detail[0].index + 1)).slice(0));
		});
	});

	function clock() {
		var d = new Date();
		var day = d.getDate();
		var hours = d.getHours();
		var minutes = d.getMinutes();
		var seconds = d.getSeconds();

		var month = new Array(
			'января',
			'февраля',
			'марта',
			'апреля',
			'мая',
			'июня',
			'июля',
			'августа',
			'сентября',
			'октября',
			'ноября',
			'декабря'
		);
		var month_en = new Array(
			'january',
			'february',
			'marth',
			'april',
			'may',
			'june',
			'jule',
			'august',
			'september',
			'october',
			'november',
			'december'
		);
		var days = new Array(
			'Воскресенье',
			'Понедельник',
			'Вторник',
			'Среда',
			'Четверг',
			'Пятница',
			'Суббота'
		);

		if (day <= 9) day = '0' + day;
		if (hours <= 9) hours = '0' + hours;
		if (minutes <= 9) minutes = '0' + minutes;
		if (seconds <= 9) seconds = '0' + seconds;

		var date_date =
			day + ' ' + month[d.getMonth()] + ' ' + d.getFullYear() + ' г.';
		var date_date2 = day + ' ' + month[d.getMonth()] + ' ';
		var date_date_en =
			day + ' ' + month_en[d.getMonth()] + ' ' + d.getFullYear() + ' y.';
		var date_time2 =
			hours +
			"<span class='anim-dott'>:</span>" +
			minutes +
			"<span class='anim-dott'>:</span>" +
			seconds;
		var date_time = hours + "<span class='anim-dott'>:</span>" + minutes;

		if (document.layers) {
			document.layers.date.document.write(date_time);
			document.layers.date.document.close();
			document.layers.time.document.write(date_time);
			document.layers.time.document.close();
		} else {
			if (document.getElementById('day')) {
				document.getElementById('day').innerHTML = date_date;
			}
			if (document.getElementById('day2')) {
				document.getElementById('day2').innerHTML = date_date2;
			}
			if (document.getElementById('day-en')) {
				document.getElementById('day-en').innerHTML = date_date_en;
			}
			if (document.getElementById('time')) {
				document.getElementById('time').innerHTML = date_time;
			}
			if (document.getElementById('time-menu')) {
				document.getElementById('time-menu').innerHTML = date_time;
			}
			if (document.getElementById('time2')) {
				document.getElementById('time2').innerHTML = date_time2;
			}
		}
		setTimeout(clock, 1000);
	}
	clock();

	// видео обычное
	$('.video')
		.parent()
		.click(function () {
			if ($(this).children('.video').get(0).paused) {
				$(this).children('.video').get(0).play();
				$(this).children('.playpause').fadeOut();
			} else {
				$(this).children('.video').get(0).pause();
				$(this).children('.playpause').fadeIn();
			}
		});

	// видео ютуб
	var video = {
		init: function () {
			video.play();
		},
		play: function () {
			$('body').on('click', '#play-video-btn', function (e) {
				video.setSrc(this);
			});
		},
		setSrc: function (el) {
			if (el) {
				var video_id = $(el).data('id');
				var url =
					'//www.youtube.com/embed/' +
					video_id +
					'?enablejsapi=1&version=3&showinfo=0&playerapiid=ytplayer&autoplay=1';
				$('img#embed-video-preview').hide();
				$('#play-video-btn').hide();
				$('iframe#embed-video-frame').attr('src', url).fadeIn();
			}
		},
	};
	video.init();

	// Маска телефона
	if ($('.f_phone').length > 0) {
		Inputmask({
			mask: '+7 (999) 999-9999',
		}).mask('.f_phone');
	} else {
		// console.log('not found');
	}

	if ($('.cabinet-bank-card__date').length > 0) {
		Inputmask({
			mask: '99/99',
			clearIncomplete: true,
			showMaskOnHover: false,
			showMaskOnFocus: false,
		}).mask('.cabinet-bank-card__date');
	} else {
		// console.log('not found');
	}

	if ($('.cabinet-bank-card__number').length > 0) {
		Inputmask({
			mask: '9999 9999 9999 9999',
			clearIncomplete: true,
			showMaskOnHover: false,
			showMaskOnFocus: false,
		}).mask('.cabinet-bank-card__number');
	} else {
		// console.log('not found');
	}

	let inputScrollNum = 1;
	// Инпут года
	const inputArchive = document.querySelectorAll('.input_archive .select');

	inputArchive.forEach((element) => {
		const $this = $(element);
		const $styledSelect = $(element).find('.select-styled');
		const $listItems = $(element).find('li');
		const $list = $(element).find('.select-options');
		const inputScrollNumCurrent = inputScrollNum;

		$list.attr('id', `inputScroll${inputScrollNumCurrent}`);
		$styledSelect.click(function (e) {
			e.stopPropagation();
			$('div.select-styled.active')
				.not(this)
				.each(function () {
					$(this)
						.removeClass('active')
						.next('ul.select-options')
						.fadeOut('fast');
				});
			$(this)
				.toggleClass('active')
				.next('ul.select-options')
				.fadeToggle('fast');

			let inputScroll = Scrollbar.init(
				document.querySelector(`#inputScroll${inputScrollNumCurrent}`),
				{
					alwaysShowTracks: true,
				}
			);
			inputScroll.update();
		});
		$listItems.click(function (e) {
			$styledSelect.text($(this).text()).removeClass('active');
			$('.select-options').fadeOut('fast');
		});
		$(document).on('touchstart mousedown', function (e) {
			if ($this.has(e.target).length === 0) {
				$list.fadeOut('fast');
				$styledSelect.removeClass('active');
			}
		});
		inputScrollNum++;
	});

	//  Стилизация селекта
	$('.input-js select').each(function () {
		let inputScrollNumCurrent = inputScrollNum;
		let $this = $(this),
			numberOfOptions = $(this).children('option').length;
		$this.addClass('select-hidden');
		$this.wrap('<div class="select"></div>');
		$this.after('<div class="select-styled"></div>');
		let $styledSelect = $this.next('div.select-styled');
		// $styledSelect.text($this.attr('select_name'));
		console.log($this.attr('select_name') );
		console.log($('option:selected', this).text() );
		$this.attr('select_name') 
			? $styledSelect.text($this.attr('select_name'))
			: $styledSelect.text($('option:selected', this).text());

		let $list = $('<ul />', {
			id: 'inputScroll' + inputScrollNumCurrent,
			class: 'select-options',
		}).insertAfter($styledSelect);
		for (let i = 0; i < numberOfOptions; i++) {
			$('<li />', {
				text: $this.children('option').eq(i).text(),
				rel: $this.children('option').eq(i).val(),
			}).appendTo($list);
		}
		let $listItems = $list.children('li');
		$styledSelect.click(function (e) {
			e.stopPropagation();
			$('div.select-styled.active')
				.not(this)
				.each(function () {
					$(this)
						.removeClass('active')
						.next('ul.select-options')
						.fadeOut('fast');
				});
			$(this)
				.toggleClass('active')
				.next('ul.select-options')
				.fadeToggle('fast');

			// console.log(inputScrollNumCurrent);
			if ($(`#inputScroll${inputScrollNumCurrent}`).height() >= 160) {
				let inputScroll = Scrollbar.init(
					document.querySelector(`#inputScroll${inputScrollNumCurrent}`),
					{
						alwaysShowTracks: true,
					}
				);
				inputScroll.update();
			}
		});
		$listItems.click(function (e) {
			$styledSelect.addClass('select-styled-black');
			e.stopPropagation();
			$styledSelect.text($(this).text()).removeClass('active');
			$this.val($(this).attr('rel'));
			$list.hide();
			console.log($this.val());
			// $("input[type='submit'].filterApply").trigger('click');
		});
		$(document).on('touchstart mousedown', function (e) {
			if (
				$.contains(
					document.querySelector(`#inputScroll${inputScrollNumCurrent}`),
					e.target
				) === false
			) {
				$list.hide();
				$styledSelect.removeClass('active');
			}
		});
		inputScrollNum++;
	});

	//стилизация бургера меню
	function menuCheck() {
		var menu_attr = $('#offcanvas-nav').hasClass('uk-open');
		if (menu_attr) {
			$('.header_top_menu').addClass('open');
		} else {
			$('.header_top_menu').removeClass('open');
		}
	}

	UIkit.util.on('#offcanvas-nav', 'shown', function () {
		menuCheck();
	});
	UIkit.util.on('#offcanvas-nav', 'hidden', function () {
		menuCheck();
	});

	$('.menu-list a[uk-scroll]').click(function () {
		UIkit.offcanvas('#offcanvas-nav').hide();
	});

	$('a.transition').click(function (event) {
		event.preventDefault();
		var linkLocation = this.href;
		$('html').css('background', '#fff');
		$('body').fadeOut(700, redirectPage);

		function redirectPage() {
			window.location = linkLocation;
		}
	});

	// Ввод в инупт суммы лейблов
	[...document.querySelectorAll('.cabinet-donation__inputs')].forEach((el) => {
		[...el.querySelectorAll('input[type="radio"]')].forEach((input) => {
			input.addEventListener('click', () => {
				el.querySelector('input[type="text"]').value = input.value;
			});
		});
	});

	function getDataRentForm(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function () {
				UIkit.modal('#modal-calling').hide();
				$('a[href="#modal-calling"]').attr('href', '#success');
				UIkit.modal('#success').show();
				setTimeout(function () {
					UIkit.modal('#success').hide();
				}, 3000);
			},
		});
	}
	$('form#zay_form').on('submit', getDataRentForm);

	function getDataRentForm2(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function () {
				UIkit.modal('#modal-calling-2').hide();
				$('a[href="#modal-calling-2"]').attr('href', '#success');
				UIkit.modal('#success').show();
				setTimeout(function () {
					UIkit.modal('#success').hide();
				}, 3000);
			},
		});
	}
	$('form#zay_form2').on('submit', getDataRentForm2);

	function getDataRentForm3(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function (data) {
				console.log(data);
				document.querySelector('#registration-form__error').innerHTML = '';
				if (data.STATUS === 'ERROR') {
					document.querySelector('#registration-form__error').innerHTML =
						data.MESSAGES[0];
				} else {
					UIkit.modal('#success_reg').show();
					setTimeout(function () {
						window.location = 'https://ecologyfund.ru/personal/';
					}, 1500);
				}
			},

			error: function (jqXHR, exception) {
				console.log(jqXHR);
				console.log(exception);
				if (jqXHR.status === 0) {
					alert('Not connect. Verify Network.');
				} else if (jqXHR.status == 404) {
					alert('Requested page not found (404).');
				} else if (jqXHR.status == 500) {
					alert('Internal Server Error (500).');
				} else if (exception === 'parsererror') {
					alert('Requested JSON parse failed.');
				} else if (exception === 'timeout') {
					alert('Time out error.');
				} else if (exception === 'abort') {
					alert('Ajax request aborted.');
				} else {
					alert('Uncaught Error. ' + jqXHR.responseText);
				}
			},
		});
	}
	$('form#registration-form').on('submit', getDataRentForm3);

	function getDataRentForm4(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function () {
				UIkit.modal('#success_change-lk').show();
				// setTimeout(function () {
				// 	window.location = 'https://ecologyfund.ru/';
				// }, 3000);
			},
		});
	}
	$('form#form_cabinet-contacts').on('submit', getDataRentForm4);

	function getDataRentForm5(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function (data) {
				console.log(data);
				if (data.STATUS === 'OK') {
					UIkit.modal('#success_credit-info-unsave').show();
					setTimeout(function () {
						location.reload();
					}, 1500);
				}
			},
		});
	}
	$('form#form_cabinet-bank-card').on('submit', getDataRentForm5);

	// при bind=1 вывести попап успешной привязки
	const url = new URL(document.location);
	const { href } = url;
	const params = url.searchParams;
	const bind = params.get('bind');
	if (bind) {
		UIkit.modal('#success_credit-info').show();
	}


	function getDataRentForm6(e) {
		document.querySelector('#form_cabinet-donation .uk-button-default').setAttribute('disabled', 'disabled');
		UIkit.modal('#payment-waiting').show();
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		var dataFormArray = $(this).serializeArray();
		var valHelpTwo = dataFormArray.find((el) => el.name === 'help2')?.value;
		valHelpTwo
			? (document.querySelector('#success_choose-summ__value').innerHTML =
					valHelpTwo)
			: null;

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function (data) {
				UIkit.modal('#payment-waiting').hide();
				console.log(data);
				document.querySelector('#form_cabinet-donation .uk-button-default').removeAttribute('disabled');
				if (data.STATUS === 'ERROR') {
					document.querySelector('.cabinet-donation__text-1').innerHTML = data.ERRORINFO;
				}
				if (data.STATUS === 'OK') {
					UIkit.modal('#success_choose-summ').show();
					setTimeout(function () {
						// location.reload();
						document.location = 'https://ecologyfund.ru/personal/';
					}, 1500);
				}
			},
		});
	}
	$('form#form_cabinet-donation').on('submit', getDataRentForm6);

	function getDataRentForm7(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function () {
				UIkit.modal('#success_change-pass').show();
				setTimeout(function () {
					document.location = 'https://ecologyfund.ru/personal/';
				}, 1500);
			},
		});
	}
	$('form#form-cabinet-change-pass').on('submit', getDataRentForm7);

	function getDataRentForm8(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function (data) {
				console.log(data);
				document.querySelector('#form_modal-cabinet-in__error').innerHTML = '';
				if (data.STATUS === 'ERROR') {
					document.querySelector('#form_modal-cabinet-in__error').innerHTML =
						data.MESSAGES[0];
				}
				if (data.STATUS === 'OK') {
					document.location = 'https://ecologyfund.ru/personal/';
				}
			},
			error: function (jqXHR, exception) {
				console.log(jqXHR);
				console.log(exception);
				if (jqXHR.status === 0) {
					alert('Not connect. Verify Network.');
				} else if (jqXHR.status == 404) {
					alert('Requested page not found (404).');
				} else if (jqXHR.status == 500) {
					alert('Internal Server Error (500).');
				} else if (exception === 'parsererror') {
					alert('Requested JSON parse failed.');
				} else if (exception === 'timeout') {
					alert('Time out error.');
				} else if (exception === 'abort') {
					alert('Ajax request aborted.');
				} else {
					alert('Uncaught Error. ' + jqXHR.responseText);
				}
			},
		});
	}
	$('form#form_modal-cabinet-in').on('submit', getDataRentForm8);

	function getDataRentForm9(e) {
		e.preventDefault();
		var $form = $(this);
		var action = $(this).attr('action');
		var dataForm = $(this).serialize();

		$.ajax({
			url: action,
			type: 'POST',
			data: dataForm,
			success: function (data) {
				console.log(data);
				document.querySelector('#form_modal-remind-pass__error').innerHTML = '';
				if (data.STATUS === 'ERROR' && data.MESSAGES === 'No user') {
					document.querySelector('#form_modal-remind-pass__error').innerHTML =
						'Указанного логина не существует';
				}
				if (data.STATUS === 'OK') {
					UIkit.modal('#success_remind-pass').show();
					setTimeout(function () {
						location.reload();
					}, 1500);
				}
			},
			error: function (jqXHR, exception) {
				console.log(jqXHR);
				console.log(exception);
				if (jqXHR.status === 0) {
					alert('Not connect. Verify Network.');
				} else if (jqXHR.status == 404) {
					alert('Requested page not found (404).');
				} else if (jqXHR.status == 500) {
					alert('Internal Server Error (500).');
				} else if (exception === 'parsererror') {
					alert('Requested JSON parse failed.');
				} else if (exception === 'timeout') {
					alert('Time out error.');
				} else if (exception === 'abort') {
					alert('Ajax request aborted.');
				} else {
					alert('Uncaught Error. ' + jqXHR.responseText);
				}
			},
		});
	}
	$('form#form_modal-remind-pass').on('submit', getDataRentForm9);

	// UIkit.modal('#success_reg').show();
});

// Анимация до якоря при переходе к другой странице
document.body.scrollTop = 0;
var windowScrolled = false;
$(document).ready(function (e) {
	if (windowScrolled != false || location.hash.length == 0) return;

	setTimeout(() => {
		var name = location.hash.substr(1);
		var name2 = name.split(';');

		if (name2[1] === undefined) {
			name2[1] = 0;
		}
		console.log(name);
		console.log(name2);
		var el = $('#' + name2[0] + ', [name=' + name2[0] + ']');

		console.log(el);

		if (el.length > 0) {
			$('body, html').animate(
				{
					scrollTop: el.offset().top - name2[1],
				},
				1000
			);

			window.scrolled = true;
		}
	}, 1500);
});
